import '@/polyfills';

import React from 'react';
import ReactDOM from 'react-dom/client'; // Import createRoot from 'react-dom/client'
import './index.css';

import App from './App';
import { AuthProvider } from '@/context/AuthContext';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Provider } from '@/components/ui/provider';
import { Toaster } from '@/components/ui/toaster.tsx';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { SentryErrorBoundary } from '@/components/errors/SentryErrorBoundary';

import { configureClient } from '@/api';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@/lib/queryClient.ts';
import { configurePdfWorker } from '@/utils/pdfConfig.ts';
import { configureSentry } from '../sentry.ts';

configureSentry();

// Triggers client side configuration with our own axios instance
configureClient();

configurePdfWorker();
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement); // Use createRoot

root.render(
	<React.StrictMode>
		<Provider>
			<GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>
				<QueryClientProvider client={queryClient}>
					<SentryErrorBoundary>
						<AuthProvider>
							<App />
							<Toaster />
						</AuthProvider>
					</SentryErrorBoundary>
					{import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
				</QueryClientProvider>
			</GoogleOAuthProvider>
		</Provider>
	</React.StrictMode>,
);
